import React from 'react'

import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { FieldGroup } from './FieldGroup'

import cn from 'classnames'
import Loading from '../../components/shared/Loading'

const ForgetPassword = () => <Link className="pull-right" to="/forgot-password"> Forgot Password ?</Link>

export const LoginForm = ({ onSubmit, onChange, validateForm, username, password, autoFocusInput, hideInputs = [], children, isBusy }) => (
  <div className="AuthContainerForm" >
    <h1>Login</h1>
    <p>To an <strong>existing</strong> Owner&apos;s Edge account</p>
    <form onSubmit={onSubmit} className="col">
      <FieldGroup
        id="username"
        label="Email Address"
        value={username}
        onChange={onChange}
        autoFocus={autoFocusInput === 'username'}
        className={cn({ 'field-group_input': true, 'field-group_input--hide': hideInputs.includes('username') })}
      />
      <FieldGroup
        id="password"
        label="Password"
        value={password}
        type="password"
        onChange={onChange}
        autoFocus={autoFocusInput === 'password'}
        className={cn({ 'field-group_input': true, 'field-group_input--hide': hideInputs.includes('password') })}
      >
        <ForgetPassword />
      </FieldGroup>
      { children }
      <Button id="login-button" type="submit" className="login" disabled={!validateForm() || isBusy}>
        {isBusy ? <Loading width="21px" height="21px" classes="spinner" /> : "Login"}
      </Button>
      <Link
        to="/signup"
        className="btn btn-link"
      > Don’t have an account? Sign-up here
      </Link>
      <p className="col-xs-12 trouble_login">
        <Link
          to="/logintrouble"
          className="btn-link"
        > Trouble logging in?
        </Link>
      </p>
    </form>
  </div >)
